<template>
  <div style="z-index: 1002;" class="common-mask vipDialog" @wheel.prevent @touchmove.stop>
    <div
      class="vipDialog-box w-full h-[90%] sm:h-auto overflow-hidden sm:w-[1320px] rounded-tr-[30px] rounded-tl-[30px] sm:rounded-br-[30px] sm:rounded-bl-[30px] relative flex flex-col items-center bg-center bg-cover"
      :style="`background-image: url(${bg});`">
      <p
        class="font-Montserrat font-bold text-2xl sm:text-[40px] sm:leading-[44px] text-text-deep text-center sm:max-w-[600px] mt-[50px]">
        {{ $t("dialog-vip-choose") }}
      </p>
      <div class="h-9 rounded-full p-[2px] m-auto flex bg-white my-6 text-[14px] sm:text-[16px]">
        <span class="h-full leading-8 px-[22px] rounded-full font-Roboto-Bold font-bold cursor-pointer"
          :class="activeDate === 0 ? 'bg-black text-white' : 'text-text-deep'" @click="activeDate = 0">{{ unit[0][0]
          }}</span>
        <span class="h-full leading-8 px-[22px] rounded-full font-Roboto-Bold font-bold cursor-pointer"
          :class="activeDate === 1 ? 'bg-black text-white' : 'text-text-deep'" @click="activeDate = 1">{{ unit[1][0]
          }}</span>
        <span class="h-full leading-8 px-[22px] rounded-full font-Roboto-Bold font-bold cursor-pointer"
          :class="activeDate === 2 ? 'bg-black text-white' : 'text-text-deep'" @click="activeDate = 2">{{ unit[2][0]
          }}</span>
      </div>
      <div class="w-full flex-1 sm:w-auto flex gap-3 px-8 overflow-x-auto sm:gap-5 sm:overscroll-none sm:px-0">
        <!-- free -->
        <div
          class="w-[300px] sm:w-[318px] rounded-t-[20px] bg-white overflow-hidden pb-10 flex-none flex flex-col sm:block">
          <div class="rounded-[20px] bg-mainColor-deep5 px-[30px] pt-[30px] pb-[22px]">
            <p class="font-Roboto-Bold font-bold text-[32px] leading-[38px] text-white">
              {{ $t("dialog-free-base") }}
            </p>
            <p class="text-[14px] leading-[16px] mt-1 mb-4 text-white-75">
              {{ $t("dialog-free-desc") }}
            </p>
            <p class="mb-3 text-white">
              <span class="font-Roboto-Bold font-bold text-[32px] leading-[38px]">$0.00</span><span
                class="font-Roboto-Bold font-bold text-[14px] leading-[16px]">/{{ unit[activeDate][1] }}</span>
            </p>

            <div v-show="!isLogin" @click="toLogin"
              class="hidden sm:flex group px-[20px] rounded-full justify-center items-center hover:gap-5 h-[44px] border border-white-line bg-white">
              <span class="text-text-deep font-Roboto-Bold font-bold pl-2">{{
                $t("dialog-free-subscription")
              }}</span>
              <span
                class="opacity-0 -translate-x-4 w-0 group-hover:opacity-100 group-hover:translate-x-0 group-hover:w-[20px] transition-all duration-300">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="arrow-move">
                  <path d="M8 2.27734L14.2225 8.49988L8 14.7224" stroke="#1F1F1F" stroke-width="2" />
                  <path d="M1.77746 8.49988H14.2225" stroke="#1F1F1F" stroke-width="2" />
                </svg>
              </span>
            </div>
          </div>
          <div class="w-[240px] mx-auto flex flex-col gap-4 mt-5 overflow-y-auto py-4">
            <div class="flex gap-4" v-for="(item, index) in packDesc" :key="index">
              <div class="w-[18px]">
                <img :src="`/assets/images/enhance/${item.support ? 'check2' : 'close2'}.svg`" width="17" height="17"
                  alt="check">
              </div>

              <!-- <span>{{(activeDate===2 && index === 0)? $t('dialog-vip-pro-feature-1'):item.text }}</span> -->
              <div class="flex-1 flex flex-col">
                <span>{{
                  item.text
                }}</span>
                <span v-if="item.desc" class="text-text-gray Roboto-14">
                  {{ item.desc }}
                </span>
              </div>
            </div>
          </div>
          <div class="relative sm:hidden px-4">
            <div class="absolute -top-[40px] left-0 w-full h-10 pages-linear"></div>
            <ArrowBtn v-show="!isLogin" :text="$t('dialog-vip-subscription')" @click="toLogin"
              class="w-full bg-text-deep cursor-pointer"></ArrowBtn>
          </div>
        </div>
        <!-- amateur -->
        <div
          class="w-[300px] sm:w-[318px] rounded-t-[20px] bg-white overflow-hidden pb-10 flex-none flex flex-col sm:block">
          <div class="relative rounded-[20px] bg-mainColor px-[30px] pt-[30px] pb-[22px]">
            <!-- <img
              class="absolute top-0 right-0 w-1/2 h-9"
              src="/assets/images/perCenter/price80.png"
              alt=""
            /> -->
            <p class="font-Roboto-Bold font-bold text-[32px] leading-[38px] text-white">
              {{ $t("dialog-vip-base") }}
            </p>
            <p class="text-[14px] leading-[16px] mt-1 mb-4 text-white-75">
              {{ $t("dialog-vip-base-desc") }}
            </p>
            <p class="mb-3 text-white">
              <span class="font-Roboto-Bold font-bold text-[32px] leading-[38px]">${{ packPrice[activeDate][0].price
                }}</span><span class="Roboto-vip-1 font-bold text-[14px] leading-[16px]">/{{ unit[activeDate][1]
                }}</span>
              <!-- <span
                style="text-decoration: line-through"
                class="ml-10 font-Roboto-Bold font-bold text-[16px] leading-[38px]"
                >${{ packPrice[activeDate][0].price }}</span
              ><span
                style="text-decoration: line-through"
                class="font-Roboto-Bold font-bold text-[12px] leading-[16px]"
                >/{{ unit[activeDate][1] }}</span
              > -->
            </p>
            <div v-show="!isVip"
              class="hidden sm:flex group px-[20px] rounded-full justify-center items-center hover:gap-5 h-[44px] border border-white-line"
              @click="commit(packPrice[activeDate][0].type)" :class="isVip
                ? 'bg-btn-gray cursor-not-allowed'
                : 'bg-white cursor-pointer'
                ">
              <span class="text-text-deep font-Roboto-Bold font-bold pl-2">{{
                $t("dialog-vip-subscription")
              }}</span>
              <span
                class="opacity-0 -translate-x-4 w-0 group-hover:opacity-100 group-hover:translate-x-0 group-hover:w-[20px] transition-all duration-300">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="arrow-move">
                  <path d="M8 2.27734L14.2225 8.49988L8 14.7224" stroke="#1F1F1F" stroke-width="2" />
                  <path d="M1.77746 8.49988H14.2225" stroke="#1F1F1F" stroke-width="2" />
                </svg>
              </span>
            </div>
          </div>
          <div class="w-[240px] mx-auto flex flex-col gap-4 mt-5 overflow-y-auto py-4">
            <div class="flex gap-4" v-for="(item, index) in packDesc1" :key="index">
              <div class="w-[18]">
                <img :src="`/assets/images/enhance/${item.support ? 'check2' : 'close2'}.svg`" width="17" height="17"
                  alt="check">
              </div>
              <div class="flex-1 flex flex-col">
                <span>{{
                  item.text
                }}</span>
                <span v-if="item.desc" class="text-text-gray Roboto-14">
                  {{ item.desc }}
                </span>
              </div>
            </div>
          </div>
          <div class="relative sm:hidden px-4">
            <div class="absolute -top-[40px] left-0 w-full h-10 pages-linear"></div>
            <ArrowBtn v-show="!isVip" :text="$t('dialog-vip-subscription')"
              @click="commit(packPrice[activeDate][0].type)" class="w-full" :class="isVip
                ? 'bg-btn-gray cursor-not-allowed'
                : 'bg-text-deep cursor-pointer'
                "></ArrowBtn>
          </div>
        </div>
        <!-- pro -->
        <div
          class="w-[300px] sm:w-[318px] rounded-t-[20px] bg-white overflow-hidden pb-10 flex-none flex flex-col sm:block">
          <div class="rounded-[20px] px-[30px] pt-[30px] pb-[22px] bg-center bg-cover"
            :style="`background-image: url(${pack2bg});`">
            <p class="font-Roboto-Bold font-bold text-[32px] leading-[38px] text-white">
              {{ $t("dialog-vip-pro") }}
            </p>
            <p class="text-[14px] leading-[16px] mt-1 mb-4 text-white-75">
              {{ $t("dialog-vip-pro-desc") }}
            </p>
            <p class="mb-3 text-white">
              <span class="font-Roboto-Bold font-bold text-[32px] leading-[38px]">${{ packPrice[activeDate][1].price
                }}</span><span class="font-Roboto-Bold font-bold text-[14px] leading-[16px]">/{{ unit[activeDate][1]
                }}</span>
            </p>
            <div v-show="!isVip"
              class="group hidden sm:flex px-[20px] rounded-full justify-center items-center hover:gap-5 h-[44px] shadow-[0px_6px_12px_0px_rgba(94,94,108,0.16)"
              @click="commit(packPrice[activeDate][1].type)" :class="isVip
                ? 'bg-btn-gray cursor-not-allowed'
                : 'bg-white cursor-pointer'
                ">
              <span class="text-text-deep font-Roboto-Bold font-bold pl-2">{{
                $t("dialog-vip-subscription")
              }}</span>
              <span
                class="opacity-0 -translate-x-4 w-0 group-hover:opacity-100 group-hover:translate-x-0 group-hover:w-[20px] transition-all duration-300">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="arrow-move">
                  <path d="M8 2.27734L14.2225 8.49988L8 14.7224" stroke="#1F1F1F" stroke-width="2" />
                  <path d="M1.77746 8.49988H14.2225" stroke="#1F1F1F" stroke-width="2" />
                </svg>
              </span>
            </div>
          </div>
          <div class="w-[240px] mx-auto flex flex-col gap-4 mt-5 overflow-y-auto py-4">
            <div class="flex gap-4" v-for="(item, index) in packDesc2" :key="index">
              <div class="w-[18]">
                <img :src="`/assets/images/enhance/${item.support ? 'check2' : 'close2'}.svg`" width="17" height="17"
                  alt="check">
              </div>
              <div class="flex-1 flex flex-col">
                <span>{{ item.text }}</span>
                <span v-if="item.desc" class="text-text-gray Roboto-14">
                  {{ item.desc }}
                </span>
              </div>
            </div>
          </div>
          <div class="relative sm:hidden px-4">
            <div class="absolute -top-[40px] left-0 w-full h-10 pages-linear"></div>
            <ArrowBtn v-show="!isVip" :text="$t('dialog-vip-subscription')"
              @click="commit(packPrice[activeDate][1].type)" :class="isVip
                ? 'bg-btn-gray cursor-not-allowed'
                : 'bg-text-deep cursor-pointer'
                " class="w-full" />
          </div>
        </div>
      </div>
      <span class="p-5 absolute right-0 top-0 cursor-pointer" @click="onClose">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.37307 1.609L9.99266 9.22449L17.5313 1.68546C18.045 1.22783 18.5768 1.50106 18.7892 1.73044C18.9255 1.89655 18.9958 2.10707 18.9867 2.32176C18.9776 2.53644 18.8897 2.74024 18.7398 2.89418L11.2 10.4321L18.7398 17.9677C19.0748 18.2488 19.0748 18.7998 18.8061 19.1079C18.5363 19.4148 18.0417 19.5925 17.5751 19.2282L9.99266 11.6397L2.40118 19.2316C2.06843 19.5295 1.51983 19.4688 1.24891 19.1731C0.976862 18.8763 0.873439 18.3635 1.22081 18.0015L8.7853 10.4321L1.25228 2.89418C0.976862 2.59059 0.881308 2.03515 1.25228 1.68546C1.62326 1.33578 2.17635 1.38412 2.37307 1.609Z"
            fill="#8A8EA1" />
        </svg>
      </span>
    </div>
  </div>
</template>
<script setup>
import { useMainStore } from "@/store/index";
import { MemberType, MemberTypePrice } from "~/utils/type";
const mainStore = useMainStore();
const { t } = useI18n();
const packDesc = ref([
  { support: true, text: t("dialog-free-feature-1") },
  {
    support: true,
    text: t("dialog-free-feature-2", { num: 10 }),
    // desc: t("dialog-free-feature-2-desc"),
  },
  { support: false, text: t("dialog-vip-base-feature-6") },
  { support: false, text: t("dialog-vip-base-feature-7") },
]);
const packDesc1 = ref([
  { support: true, text: t("dialog-vip-base-feature-1") },
  // {
  //   support: true,
  //   text: t("dialog-free-feature-2", { num: 40 }),
  //   // desc: t("dialog-free-feature-2-desc"),
  // },
  { support: true, text: t("dialog-vip-pro-feature-2") },
  { support: true, text: t("dialog-vip-base-feature-3") },
  // { support: true, text: t("dialog-vip-base-feature-4") },
  { support: true, text: t("dialog-vip-base-feature-5") },
  { support: false, text: t("dialog-vip-base-feature-6") },
  { support: false, text: t("dialog-vip-base-feature-7") },
]);
const packDesc2 = ref([
  { support: true, text: t("dialog-vip-pro-feature-1") },
  { support: true, text: t("dialog-vip-pro-feature-2") },
  { support: true, text: t("dialog-vip-base-feature-3") },
  // { support: true, text: t("dialog-vip-pro-feature-3") },
  { support: true, text: t("dialog-vip-base-feature-5") },
  { support: true, text: t("dialog-vip-base-feature-6") },
  { support: false, text: t("dialog-vip-base-feature-7") },
]);
const activeDate = ref(0);
const packPrice = ref({
  // 周
  0: [
    { price: MemberTypePrice[1], type: MemberType.Week },
    { price: MemberTypePrice[3], type: MemberType.WeekPro },
    { price: MemberTypePrice[0], type: MemberType.None },
  ],
  // 月
  1: [
    { price: MemberTypePrice[5], type: MemberType.Month },
    { price: MemberTypePrice[6], type: MemberType.MonthPro },
    { price: MemberTypePrice[0], type: MemberType.None },
  ],
  // 年
  2: [
    { price: MemberTypePrice[4], type: MemberType.Year },
    { price: MemberTypePrice[2], type: MemberType.YearPro },
    { price: MemberTypePrice[0], type: MemberType.None },
  ],
});
const unit = ref({
  0: [t("Weekly"), t("week")],
  1: [t("Monthly"), t("month")],
  2: [t("Yearly"), t("year")],
});
const bg =
  "data:image/webp;base64,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";
const pack2bg =
  "data:image/webp;base64,UklGRkQEAABXRUJQVlA4IDgEAADQIwCdASo+AeoAPpFInUwlsy+qoZJJEmASCWlu3/75uvcy3k5NrbnicJe1aXnSZ7naIKZL5EwfG2abHQuGUNNisyYQEfCqxqTuiJ2Ug4M8BIiikzyPj7w+8XGPS+xDP8uqEPzWmvD2X9eOP0gFox1ZnqlUj/Z8w5G1FsaTBeP4BXg9T0ZfTH4sWeTi/nDMydh7Y2weWLebtAhVJmeppRjQWqwR6pNA8G24la8orLVt/q53LhwHaqORKmY98sfXjlDueTNyItw4gvYwcETUjbEaSK6CHjc1ubIbvDhqVR1VIkrWwwRIHSJfaDdIjN5PQHcBiFmnx8kT0XvRZ609b6UcrCCjb+Ax78OHTBFhUF95rlOsU/bcAsIgTziElxuq2T+GdhQtvrAAAP7+V4Nn/1CpHXvspY56LeBRduYmryLulMfj6z328RhuOEFfevBd1SLIE2OdNSDPbss6ZY1LZDYVDFECNYn645hwxXhZrp5qJa9jglObY7sKO5SNU2vxhJnpEJn8d+vNbOJzZttStcMdCUr3QIrrZiYQj93FZu4WNgMLKBoDF+xafBtpczgmU1LzdKh4B8Al1U21yNfaQQBg+4bSBcn3KjjTj4pfDfRcDk9CnwimNvUgOddIbRbM74RTlLx00cg581x2MfteBg2oK4gYbpFW3w3Grzu3Owsa6wdm2xsDHhAnVPGxFthNySG9UgxUSWEe9Yrwz3SfVW+KBesltODc8J8ck3bV99V2R3Ql0PWgGHLGy+vED3/4vX0/UAZdGCvcXMJilC0ao5ssn40EM2+WZVJh1udvO+y4KqoHvk/+IUmYXskdexOy/g8fr2hHJsGVUZOuAwTEwhz7z7Bj7Sy8y1eroKLwtAYDsv/pUYNE4PqgQK8r0C8tdxqxixgPSuBdnLfBIdnP7nxzYHEMYmgBNOUBZAiK3VzLhmfO7vj7idWMKtdH0uRpwKnY73dXxVK2rSw7rXJhs0WzH10/OySefvKwok/OCQFzxR99WEcRxkijvteqlNDhqBsg8+qR5TSKwXu6FWzPSz67TThAPEBc3rOskelGbmE0gXrAMnWa2agGo2hUgnoaoIOS0rT8VF0jqkHuTXLNiPo09kzpT3Nb0ASjFyh4x3ixOLinu0C4x6V/6q2/f2Zv6wMpEQrDt6sTcC3nWrY+16PZJCDLSeXM4dmo/KGUgLbYIWsbQFVgR/nlkDG/Mxa5e3PMGZUYNQFUgAbVySv5OECfZXPt6kL94z4RB+xCRE95gFbdYmqdMEwuAxdPKtmMeUwAAPX65rnYFLxZvZ4f+c1X+s6mjPffavUaJo+UDkrl1COhrjiyIiEkK9IQK6/5thefoIFK0n2VBL8/9Bk1w5gCaISrYYdRoinLtYervf0iBi8CABowroomMKxc8ZDaaShvwAVaO8OmQCn7E7FJziqS7QNZs4cAAAA=";

const { isLogin, isVip } = useUserInfo();
onMounted(() => { });

function onClose() {
  useLogEvent({ eventName: "vip-close" });
  mainStore.setVipToLogin(false);
  mainStore.setVisibleVipDialog(false);
}

function commit(type) {
  if (isVip.value) {
    return;
  }
  useLogEvent({ eventName: "vipDiaog-buy",eventParams:{type} });
  if (!isLogin.value) {
    mainStore.setVisibleVipDialog(false);
    mainStore.setVipToLogin(true);
    mainStore.setVisibleLogin(true);
    return;
  }
  mainStore.setPackageType(type);
  mainStore.setVisibleVipDialog(false);
  mainStore.setVisiblePay(true);
}
function toLogin() {
  if (!isLogin.value) {
    mainStore.setVisibleVipDialog(false)
    mainStore.setVisibleLogin(true)
  }
}
</script>
<style scoped>
@media screen and (max-width: 640px) {
  .vipDialog {
    flex-direction: column;
    justify-content: end;
  }
}

@media screen and (min-width: 960px) and (max-height: 600px) {
  .vipDialog-box {
    height: 100%;
  }
}
@media (max-height: 650px) {
  .vipDialog-box {
    transform: scale(0.7);
  }
}
@media (min-height: 650px) {
  .vipDialog-box {
    transform: scale(0.8);
  }
}
@media (min-height: 750px) {
  .vipDialog-box {
    transform: scale(1);
  }
}
.pages-linear {
  /* background-color: red; */
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}
</style>
